type Procedure = (...args: any[]) => void

function throttle<F extends Procedure>(func: F, timeout: number): ((this: ThisParameterType<F>, ...args: Parameters<F>) => void) & { flush(): void } {
  let isThrottled
  let context
  let savedArgs
  let timeoutId

  function flush() {
    clearTimeout(timeoutId)
  }

  function wrapper(this: ThisParameterType<F>, ...args: Parameters<F>): void {
    if (isThrottled) {
      savedArgs = args
      context = this

      return
    }

    func.apply(this, args)
    isThrottled = true

    timeoutId = setTimeout(() => {
      isThrottled = false

      if (savedArgs) {
        wrapper.apply(context, savedArgs)
        savedArgs = null
        context = null
      }
    }, timeout)
  }

  wrapper.flush = flush

  return wrapper
}


export default throttle
